<template>
  <div class="body-wrapper">
    <QuestionImage
        :attaches="questionData?.content?.attach
    ?.filter(item => item.file?.attachUrl)
    ?.map(item => ({ attachUrl: item.file.attachUrl })) || []"
    />
    <h5 class="title">
      {{ questionData?.name }}
    </h5>


    <div class="number-input-wrapper">
      <div class="left-button">
        <img src="@/assets/images/minus.svg" width="18" height="18" />
      </div>

      <div class="number-input">
        <span>0</span>
      </div>

      <div class="right-button">
        <img src="@/assets/images/add.svg" width="18" height="18" />

      </div>
    </div>
  </div>
</template>

<script>
import QuestionImage from "@/components/QuestionImage.vue";

export default{
  components: {QuestionImage},
  props:{
    questionData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.body-wrapper {
  display: flex;
  flex-direction: column;
  gap: 3px;
  width: 100%;
  padding: 10px;
}

.title {
  font-size: 18px;
  color: #040C2D;
  margin: 0;
  padding: 0;
  font-family: euclid_semi_bold, sans-serif;
}

.number-input-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-top: 20px;
}

.left-button, .right-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: #FCFCFD;
  border: 1px solid #D0D5DD;
  cursor: pointer;
}

.left-button {
  border-bottom-left-radius: 9px;
  border-top-left-radius: 9px;
}

.right-button {
  border-bottom-right-radius: 9px;
  border-top-right-radius: 9px;
}

.number-input {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #040C2D;
  font-family: euclid_regular, sans-serif;
  border-top: 1px solid #D0D5DD;
  border-bottom: 1px solid #D0D5DD;
  background-color: #fff;
  height: 40px;
}



</style>
